export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  let type = 'social_media';
  bm.add(type, {
    label: type,
    category: 'Social',
    content: {
      activeOnRender: 1,
      void: true,
      type: type,
      style: {
        width: '30%',
        height: '60%',
        overflow: 'hidden',
      },
      resizable: {
        step: 0.2,
        minDim: 10,
        currentUnit: 1,
        autoHeight: true,
      },
    },
    attributes: {
      class: 'fa fa-play', //icon in the panel
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/medias/blocks.js